function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "357.5px",
    height: "372.3px",
    viewBox: "0 0 357.5 372.3",
    style: {
      enableBackground: "new 0 0 357.5 372.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M93.9,347.7c-8.4-1.5-16.4-3.6-23.1-8.3c-12.2-8.4-17.6-19-15.7-32.3c0.5,0.2,0.9,0.2,0.9,0.3 c0.7,6.4,4.7,8.6,12.4,6.7c3.5-0.9,12-2.4,14.7-3c3.8,6.7,4,12.8,8.3,18.6c4.3,5.8,7.8,11.7,13,17.1c-0.2,0.1-1,0.5-1.8,0.9 C99.7,347.7,96.8,347.7,93.9,347.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M33.4,183.9c0.5,0-0.2-1.4,0-1.2c5.3,4.6,15.4,5.9,22.3,2.8c0.9-0.4-0.3,0.7,1.7,0.6 c-0.6,8.7,0.5,17.1,6.8,24.7c-10.8,0.4-22.8-5.8-27.8-13.9c-1.2-1.9-2-3.9-3-5.9C33.4,188.7,33.4,186.3,33.4,183.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M325.4,189.6c-5,8.6-14.2,13.2-25.7,13.2c-0.1-8.9-0.2-17.7-0.3-26.6c1,0,2,0,3,0 c0.5,1.4,0.7,3.9,1.6,4c4.3,0.7,6.8,2,11.2,2.1c2.7,0.1,7.4-1.2,10-1.3C325.3,183.8,325.4,186.7,325.4,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M208.4,273.3c8.4,15,25,29.1,41.7,34.4c2.6,0.8,3.2,1.9,2,4.4c-3.5,6.9-9.1,12-14.5,17.4 c-2,2.1-3.7,1.8-5.6-0.2c-12.5-13.4-26-32.3-32-49.4c-0.9-2.6,0.4-4,2.7-4.9C204.6,274.5,206.5,273.9,208.4,273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M100.2,309.8c12.8,1.3,24.2-2.4,34.9-8c6.1-3.2,11.6-7.5,17.3-11.3c0.8-0.5,1.9-0.8,4.1-1.6 c-3.6,10.4-10,18.1-15,26.5c-5.1,8.4-11.1,16.2-19.7,22.3C112.9,329.6,104.5,321,100.2,309.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M250.4,345.1c4.9-5.9,10-11.3,14.1-17.4c4.1-6,5.9-13.5,9.1-19.4c8.5,5.7,19.7,4.9,29.4,4 C307,330.8,272.6,352,250.4,345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M109.8,258.3c-20.4-7.4-42.6-56.5-35.5-80.7c0.8,4.8,1.3,8.9,2.2,12.9c3.3,14.7,10.3,27.6,22.3,37.5 c5.1,4.2,11,7.4,16.8,10.8c2.2,1.3,2.6,2.2,1.5,4.5C114.5,248,112.2,253,109.8,258.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M241.8,234.1c11.2-1.3,20-3.8,30.6-8.7c-5.3,9.8-12.5,17.1-23.4,23.4 C246.4,243.4,243.9,238.3,241.8,234.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555"
    },
    d: "M82,254.1c-5.5-9.1-10.4-17.5-15.8-25.7c-1-1.5-3.7-2.5-5.6-2.6c-12.6-0.3-24-4-33.3-12.5 c-18.1-16.5-17.3-45.4,1.5-61.8c9.6-8.4,20.7-12.6,33.4-11.8c3.5,0.2,5.2-0.9,6.8-4.1c16.5-32.7,43.6-52.5,78.1-62.8 c8.2-2.4,16.8-3.2,25.9-4.9c-0.4-6.7,1.3-14.7-6-21.2c-7-6.2-7.8-15.8-3.6-23.8c4.1-7.7,13.2-12,21.9-10.4 c9.1,1.7,16.7,9.4,17.7,18c0.9,7.5-1.1,13.8-7.5,18.4c-3.3,2.4-5.5,4.9-4.6,9.9c1.6,9.6,1.1,9.5,10.5,11 c27.6,4.4,51.2,16.5,69.8,37.3c6.7,7.5,12.3,16.1,18.7,24c1.2,1.4,3.8,2.6,5.6,2.5c16.4-0.8,29.8,5.2,39.8,17.9 c12.8,16.2,11.7,40.1-4.7,54.9c-9.3,8.4-19.7,11.7-31.6,12.3c-1.6,0.1-3.9,0.8-4.6,2c-5.4,9.1-10.5,18.4-15.1,26.6 c8.1,5.4,17.3,10.2,24.8,16.9c22,19.7,24.7,52.7,5.9,75.2c-20.7,24.9-54.2,29.4-81.3,11.2c-23.6-15.9-35.8-40-44.7-66.1 c-1-2.9-2-5.8-3.4-10.1c-2.2,6.1-4,10.9-5.7,15.6c-10.7,29.7-26.7,55.3-56.3,69.4c-32.7,15.6-73.2-0.6-81.1-38.1 c-4.2-20,2.3-37,16.8-51.1C62.5,262.6,71.4,256.7,82,254.1z M250.9,246.8c0.9-0.4,1.4-0.6,1.7-0.8c20.5-16.1,30.1-37.9,31.3-63.2 c1.4-27.4-11.4-49.3-30.6-67.4C230,93.2,201.6,84,169.5,87.4c-40.6,4.4-69.7,25.4-86.8,62.3c-16.4,35.6-5.7,74.2,24.6,101.2 c0.9,0.8,2.1,1.4,3.9,2.4c4.2-15.9,13.2-27.5,28.1-33.4c15.4-6.1,29.7-3.7,42.3,7.9c11.9-9.1,24.5-14.8,40-10.6 C237.1,221.5,245.3,232.8,250.9,246.8z M122,335.7c16.5-14.9,28.5-32.3,35.6-53.1c1-3.1,0.4-4.9-2.9-6.1c-5.8-2.2-6.5-4.3-4.3-10 c1.6-4.1,4.8-6.2,9-7c7-1.4,11.8,2.1,16.1,8.9c1.4-8.9,3.5-16.3-1.9-23.2c-6.3-8.1-17.5-11.4-26.9-8c-10.3,3.7-16.7,13.6-16.3,25 c0.1,3.6,0.2,7.3-0.3,10.9c-0.6,3.7-3.1,6.2-7,6.8c-4.1,0.6-7.2-0.7-9.2-4.4c-0.6-1.1-1.3-2.2-2.2-3.8 c-8.7,10.3-14.2,21.2-10.2,34.6C105.1,318.1,113,327,122,335.7z M202.5,277c2.6,12.5,13.6,33.7,24.1,46.2 c9.4,11.2,6.9,9.2,15.9,0.6c13.3-12.8,18.4-28.2,13.6-46.4c-0.8-3.1-2.7-5.9-4.2-9c-2.6,2.8-4.1,5.3-6.2,6.6 c-6.4,3.6-13.1-0.8-13.3-8.7c-0.1-4.1,1.2-8.4,0.7-12.4c-1.6-12.9-15-21.8-28-19.1c-11.9,2.5-19.2,15.5-15.9,27.7 c3.5-2.1,6.9-4.9,10.8-6.3c5.6-2.1,12.7,2.5,14.4,8.4c1.5,5.6-1.2,9.3-8.3,11.2C204.9,276.1,203.8,276.5,202.5,277z M271.8,267.1 c12.8,30.2,1.3,53.2-18.7,74.2c15.9,3.7,33-2.1,42.1-13.6c10-12.7,10.5-26.2,3.4-40.2C293.3,276.7,284.6,270.2,271.8,267.1z  M102.7,345.2c-20.1-21-29.1-44.1-15.1-71.9c-19.5,2.3-34.6,24-30.8,43.1C60.9,337,82.4,350.9,102.7,345.2z M59.2,158.9 c-9.5,0-16.2,4-21.3,10.8c-5.8,7.8-5.7,16.2-1.3,24.5c4.7,8.8,12.7,12.5,23,13.8C53.5,191.5,55.3,175.4,59.2,158.9z M301.9,199.2 c14.5-0.2,24.5-10.6,23.4-23.6c-1.1-13.5-14.4-24.7-27.7-22.6C304.2,167.9,305.2,183.2,301.9,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555"
    },
    d: "M129.2,148.4c12.7,0,23,10.7,22.7,23.6c-0.2,13.1-10.9,23.7-23.7,23.5 c-12.7-0.2-22.8-10.7-22.6-23.7C105.8,158.6,116.1,148.3,129.2,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555"
    },
    d: "M211.1,170.1c-0.1-13.1,10.7-23.8,23.8-23.8c12.1,0,22,11.1,22,24.5c0,12-10.5,22.2-23,22.3 C221.6,193.1,211.2,182.7,211.1,170.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555"
    },
    d: "M172.8,217.4c-2.1-0.9-3.9-1.8-5.8-2.4c-6.7-2.1-6.7-2.1-4.1-8.7c3.4-8.9,12.5-14.3,22.6-13.8 c9.6,0.5,17.6,7,20.1,16c0.8,3,0.5,4.9-3,5.2c-1,0.1-2,0.4-2.9,0.8c-3.7,1.7-6.4,1.8-9.8-1.7C184.6,207.4,178.5,209.3,172.8,217.4z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC3F0"
    },
    d: "M333.6,60.4c5.9,0.7,11.6-0.2,15.7,4.6c4.4,5.1,6.1,10.5,3.3,16.9c-2.7,6.2-6.5,10.6-14,10.7 c-11.4,0.1-22.9,0.7-34.3,0.8c-8.6,0.1-10.9-3-9.2-11.4c2.1-10.2,3.8-20.5,6.1-30.7c1.9-8.6,8.8-14.2,15.9-13.6 c9,0.8,15.8,8,16.3,17.2C333.4,56.7,333.5,58.3,333.6,60.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.763ecb1732725b3cda039e473d94deba.svg";
export { ForwardRef as ReactComponent };